import './scss/index.scss';
import _ from 'underscore';
import { DomWeakMapUtil } from '../utils/dom';
import YoutubePlayerWrapper from '../utils/youtube-video';

const PortalPage = {
    init() {
        this.portalWrapper = document.querySelector('.portal-wrapper');
        this.activeItem = -1;
        this.slides = this.portalWrapper.querySelectorAll('.container > li');
        this.slidesAll = this.portalWrapper.querySelectorAll('.container li');
        this.isHover = false;
        this.delaySlide = undefined;
        this.primaryLinks = document.querySelectorAll('.container .item:not(.more) > a');

        this.setInitialState();
        this.bindEvents();
    },

    setInitialState() {
        this.slidesAll.forEach((element, index) => {
            element.setAttribute('data-slide-id', index);
        });
    },

    bindEvents() {
        this.portalWrapper.querySelector('.display').addEventListener('mouseenter', (e) => _.debounce(this.focus(e, 'hide'), 100));

        this.portalWrapper.querySelectorAll('.item > a').forEach((item) => {
            item.addEventListener('mouseenter', (e) => this.focus(e, 'show'));
        });

        this.portalWrapper.querySelector('.item.more > a').addEventListener('click', (e) => {
            e.preventDefault();
            e.currentTarget.parentNode.classList.toggle('expand');
        });
    },

    focusOut() {
        this.isHover = false;
        this.activeItem -= 1;

        if (this.activeItem < 0) {
            this.activeItem = 0;
        }

        const expandBtn = this.portalWrapper.querySelector('.expand');
        if (expandBtn) {
            expandBtn.classList.add('blurExpandList');
        }

        clearTimeout(this.delaySlide);
        this.activeSlide();
    },

    focusIn(el) {
        this.isHover = true;
        this.activeItem = el.parentNode.dataset.slideId;

        setTimeout(() => {
            const expandBtn = this.portalWrapper.querySelector('.expand');
            if (expandBtn) {
                expandBtn.classList.remove('blurExpandList');
            }
        }, 800);

        clearTimeout(this.delaySlide);
        this.playSlide();
    },

    focus(event, action) {
        if (action === 'show') {
            this.focusIn(event.target);
        } else if (action === 'hide') {
            this.focusOut();
        }
    },

    pauseAll() {
        const displayItems = document.querySelectorAll('.display .item');

        displayItems.forEach((item) => {
            /* eslint-disable no-param-reassign */
            item.style.opacity = 0;
            item.style.marginLeft = '15px';
            item.style.display = 'none';
            /* eslint-enable no-param-reassign */
        });
    },

    initVideos() {
        const videos = document.querySelectorAll('.es-video-player');
        videos.forEach((item) => {
            const videoPlayerYT = new YoutubePlayerWrapper(item, { isBgVideo: true });
            DomWeakMapUtil(videoPlayerYT, 'youtubePlayer');
        });
    },

    playSlide(isFirstLoad) {
        this.pauseAll();

        if (this.delaySlide) {
            const activeLink = this.slidesAll[this.activeItem].querySelector('a[data-link]');
            const currentItem = document.querySelector(`.display .item[data-item=${activeLink.dataset.link}]`);

            if (currentItem) {
                currentItem.style.opacity = 1;
                currentItem.style.marginLeft = 0;
                currentItem.style.display = 'block';
            }

            this.slidesAll.forEach((item) => {
                item.classList.remove('active');
            });

            this.slidesAll[this.activeItem].classList.add('active');
            clearTimeout(this.delaySlide);
        }

        this.activeSlide(isFirstLoad);
    },

    activeSlide(isFirstLoad) {
        this.delaySlide = setTimeout(() => {
            this.activeItem += 1;

            if (!this.isHover) {
                if (this.activeItem >= this.slides.length) {
                    this.activeItem = 0;
                    const expandBtn = this.portalWrapper.querySelector('.expand');

                    if (expandBtn) {
                        expandBtn.classList.remove('expand');
                    }
                }

                this.playSlide();
            }
        }, (isFirstLoad ? 500 : 8000));
    },

    run(isFirstLoad) {
        if (window.outerWidth >= 1024) {
            this.initVideos();
            this.playSlide(isFirstLoad);
        } else {
            this.pauseAll();
            this.activeItem = 0;
            clearTimeout(this.delaySlide);
        }
    },
};

window.addEventListener('load', () => {
    if (document.querySelector('.portal-wrapper')) {
        document.querySelector('.portal-page').classList.remove('loading');

        PortalPage.init();
        _.debounce(PortalPage.run(true), 250);
    }
});

window.addEventListener('resize', () => {
    if (document.querySelector('.portal-wrapper')) {
        _.debounce(PortalPage.run(), 250);
    }
});

export { PortalPage as default };
